// extracted by mini-css-extract-plugin
export default {"withIcon":"TimeInput_withIcon__r0fLZ","clockIcon":"TimeInput_clockIcon__HqQjD"};